//NPM LIBRARIES
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {AUfieldset, AUformGroup, AUlabel, AUlegend} from '@gov.au/form';
import AUtextInput from '@gov.au/text-inputs';
//COMPONENTS AND UTILITIES
import {validateAnswerHasValue} from '../Utilities';

const dateRegexPattern = new RegExp("^[0-9]{0,2}$");
const yearDateRegexPattern = new RegExp("^[0-9]{0,4}$");

class DateFieldset extends Component {

    constructor(props) {
        super(props);

        let answer = {
            value: '',
            subAnswers: {
                dayValue: '',
                monthValue: '',
                yearValue: ''
            }
        };
        let errorMessage = ''

        if (props.existingAnswer) {
            answer = props.existingAnswer

        } else if (props.initvalue && props.initvalue.value !== "") {
            let initialValue = props.initvalue.split("/");

            answer.subAnswers.dayValue = initialValue[0];
            answer.subAnswers.monthValue = initialValue[1];
            answer.subAnswers.yearValue = initialValue[2];
        }

        if (props.mandatory) {
            errorMessage = validateAnswerHasValue(props.type, answer, props.mandatory);
            if (errorMessage === '') {
                this.validateDate(answer);
            }
        }

        this.state = {
            answer: answer,
            errorMessage: errorMessage
        };
    }

    componentDidMount () {
        let errorMessage =  this.validateDate(this.state.answer);

        this.setState({errorMessage: errorMessage});

        let questionObject = {
            stepid: this.props.stepid,
            id: this.props.id,
            validate: this.props.validate,
            errorMessage: errorMessage,
            mandatory: this.props.mandatory,
            show: this.props.show,
            label: this.props.label,
            type: this.props.type,
            answer: this.state.answer
        }

        this.props.returnQuestionData(questionObject);
    }

    onBlur = (e) => {
        let errorMessage = validateAnswerHasValue(this.props.type, this.state.answer, this.props.mandatory);

        let answer = {
            value: this.state.answer.subAnswers.dayValue + "/" + this.state.answer.subAnswers.monthValue + "/" + this.state.answer.subAnswers.yearValue,
            subAnswers: {
                dayValue: this.state.answer.subAnswers.dayValue,
                monthValue: this.state.answer.subAnswers.monthValue,
                yearValue: this.state.answer.subAnswers.yearValue
            }
        }

        if (this.props.mandatory) {
            errorMessage = this.validateDate(answer);
        }

        this.setState({errorMessage: errorMessage});

        let questionObject = {
            stepid: this.props.stepid,
            id: this.props.id,
            validate: this.props.validate,
            errorMessage: errorMessage,
            mandatory: this.props.mandatory,
            show: this.props.show,
            label: this.props.label,
            type: this.props.type,
            answer: answer
        }

        this.props.returnQuestionData(questionObject);
    };

    onChangeDay = (e) => {
        if (!dateRegexPattern.test(e.target.value)) {
            return
        }
        this.setState({
            answer: {
                subAnswers: {
                    ...this.state.answer.subAnswers,
                    dayValue: e.target.value
                }
            }
        })
    }

    onChangeMonth = (e) => {
        if (!dateRegexPattern.test(e.target.value)) {
            return
        }
        this.setState({
            answer: {
                subAnswers: {
                    ...this.state.answer.subAnswers,
                    monthValue: e.target.value
                }
            }
        })
    }

    onChangeYear = (e) => {
        if (!yearDateRegexPattern.test(e.target.value)) {
            return
        }
        this.setState({
            answer: {
                subAnswers: {
                    ...this.state.answer.subAnswers,
                    yearValue: e.target.value
                }
            }
        })
    }

    validateDate = (answer) => {
        let errorMessge = null;
        let dateValue = answer.value;
        let validDate = moment(dateValue, 'D/M/YYYY', true).format("DD/MM/YYYY");

        if (validDate === "Invalid date") {
            return "Please check date is in correct format";
        }
        if (!this.props.allowHistoricDates) {
            const dateIsInPast = moment(dateValue, 'D/M/YYYY', true).isSameOrBefore(moment().startOf('day'));
            // const dateToday = moment(dateValue, 'D/M/YYYY', true).isSame(moment().startOf('day'));
            if (dateIsInPast) {
                return "Date entered must be in the future";
            }
        } else if (!this.props.allowFutureDates) {
            validDate = moment(dateValue, 'D/M/YYYY', true).isAfter(moment().startOf('day'));
            if (validDate) {
                return "Date entered cannot be in the future";
            }
        }

        if (this.props.validate != null) {
            errorMessge = this.props.validate(answer);
        }

        return errorMessge;
    };

    render() {

        return (

            <div className="au-form-group casa-inline-form-group">
                <AUfieldset>

                    <AUlegend>
                        <h3 className="au-display-sm">{this.props.label}</h3>
                        <span className="au-hint-text">{this.props.hintText}</span>
                    </AUlegend>

                    <AUformGroup
                        className="sub-question-group"
                        status={this.props.getStatus(this.state.errorMessage)}>

                        <div className="sub-question-group">

                            <AUformGroup
                                className="casa-inline-form-subgroup"
                                status={this.props.getStatus(this.state.errorMessage)}>

                                <AUlabel text="Day" htmlFor={`DD${this.props.id}`}/>

                                <AUtextInput
                                    id={`DD${this.props.id}`}
                                    name={`DD${this.props.id}`}
                                    block
                                    onChange={this.onChangeDay}
                                    onBlur={this.onBlur}
                                    placeholder="DD"
                                    value={this.state.answer.subAnswers.dayValue}
                                    aria-describedby={`${this.props.id}-error`}
                                    status={this.props.getStatus(this.state.errorMessage)}/>

                            </AUformGroup>

                            <AUformGroup
                                className="casa-inline-form-subgroup"
                                status={this.props.getStatus(this.state.errorMessage)}>

                                <AUlabel text="Month" htmlFor={`MM${this.props.id}`}/>

                                <AUtextInput
                                    id={`MM${this.props.id}`}
                                    name={`MM${this.props.id}`}
                                    block
                                    onChange={this.onChangeMonth}
                                    onBlur={this.onBlur}
                                    placeholder="MM"
                                    value={this.state.answer.subAnswers.monthValue}
                                    aria-describedby={`${this.props.id}-error`}
                                    status={this.props.getStatus(this.state.errorMessage)}/>

                            </AUformGroup>

                            <AUformGroup
                                className="casa-inline-form-subgroup"
                                status={this.props.getStatus(this.state.errorMessage)}>

                                <AUlabel text="Year" htmlFor={`YY${this.props.id}`}/>

                                <AUtextInput
                                    id={`YY${this.props.id}`}
                                    className="casa-inline-form-subgroup"
                                    name={`YY${this.props.id}`}
                                    block
                                    onChange={this.onChangeYear}
                                    onBlur={this.onBlur}
                                    placeholder="YYYY"
                                    value={this.state.answer.subAnswers.yearValue}
                                    aria-describedby={`${this.props.id}-error`}
                                    status={this.props.getStatus(this.state.errorMessage)}/>

                            </AUformGroup>
                        </div>
                        {this.props.createErrorMessage(this.state.errorMessage)}
                    </AUformGroup>
                </AUfieldset>
            </div>
        );
    }
}

DateFieldset.propTypes = {
    id: PropTypes.string.isRequired,
    stepid: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    hintText: PropTypes.string.isRequired,
    allowHistoricDates: PropTypes.bool.isRequired,
    allowFutureDates: PropTypes.bool.isRequired,
    validate: PropTypes.func,
    mandatory: PropTypes.bool.isRequired,
    enabled: PropTypes.bool.isRequired,
    show: PropTypes.bool.isRequired,
    existingAnswer: PropTypes.object,
    createErrorMessage: PropTypes.func,
    getStatus: PropTypes.func,
    returnQuestionData: PropTypes.func,
    initvalue: PropTypes.string,
};

DateFieldset.defaultProps = {
    mandatory: true,
    enabled: true,
    show: true,
    allowHistoricDates: true,
    allowFutureDates: true,
    hintText: "For example, 31 01 2020"
};

export default DateFieldset;